module.exports = __webpack_public_path__ + "static/media/improve.8e7367d4.png";